// extracted by mini-css-extract-plugin
module.exports = {"md":"CatalogItemsList_md_1qKMA","ios":"CatalogItemsList_ios_DkCQz","list":"CatalogItemsList_list__Mxh9"};